var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
import Language from "./language";
export var Translation;
(function (Translation) {
    Translation[Translation["AgentIsTyping"] = 0] = "AgentIsTyping";
    Translation[Translation["Back"] = 1] = "Back";
    Translation[Translation["BlockedAttachmentMessage"] = 2] = "BlockedAttachmentMessage";
    Translation[Translation["BlockedAttachmentTitle"] = 3] = "BlockedAttachmentTitle";
    Translation[Translation["Cancel"] = 4] = "Cancel";
    Translation[Translation["ChangeLanguage"] = 5] = "ChangeLanguage";
    Translation[Translation["ChatEnded"] = 6] = "ChatEnded";
    Translation[Translation["ChatInputPlaceholder"] = 7] = "ChatInputPlaceholder";
    Translation[Translation["CloseWindow"] = 8] = "CloseWindow";
    Translation[Translation["DownloadTranscriptButton"] = 9] = "DownloadTranscriptButton";
    Translation[Translation["EmailTranscript"] = 10] = "EmailTranscript";
    Translation[Translation["EndChatButton"] = 11] = "EndChatButton";
    Translation[Translation["EndChatModalMessage"] = 12] = "EndChatModalMessage";
    Translation[Translation["EndChatModalTitle"] = 13] = "EndChatModalTitle";
    Translation[Translation["EmptySelect"] = 14] = "EmptySelect";
    Translation[Translation["Error"] = 15] = "Error";
    Translation[Translation["ErrorInvalid"] = 16] = "ErrorInvalid";
    Translation[Translation["ErrorRequired"] = 17] = "ErrorRequired";
    Translation[Translation["FinishedChatMoreOptions"] = 18] = "FinishedChatMoreOptions";
    Translation[Translation["FormError"] = 19] = "FormError";
    Translation[Translation["GoToSurvey"] = 20] = "GoToSurvey";
    Translation[Translation["MinimiseWindow"] = 21] = "MinimiseWindow";
    Translation[Translation["Mute"] = 22] = "Mute";
    Translation[Translation["NoItemsFound"] = 23] = "NoItemsFound";
    Translation[Translation["NewChat"] = 24] = "NewChat";
    Translation[Translation["OpenChat"] = 25] = "OpenChat";
    Translation[Translation["PrintTranscriptButton"] = 26] = "PrintTranscriptButton";
    Translation[Translation["RequestTranscriptButton"] = 27] = "RequestTranscriptButton";
    Translation[Translation["RequestTranscriptEmailLabel"] = 28] = "RequestTranscriptEmailLabel";
    Translation[Translation["RequestTranscriptModalTitle"] = 29] = "RequestTranscriptModalTitle";
    Translation[Translation["SkipSurvey"] = 30] = "SkipSurvey";
    Translation[Translation["StartChat"] = 31] = "StartChat";
    Translation[Translation["Submit"] = 32] = "Submit";
    Translation[Translation["SurveyThanks"] = 33] = "SurveyThanks";
    Translation[Translation["Title"] = 34] = "Title";
    Translation[Translation["TooEarly"] = 35] = "TooEarly";
    Translation[Translation["TooLate"] = 36] = "TooLate";
    Translation[Translation["TranscriptRequested"] = 37] = "TranscriptRequested";
    Translation[Translation["TryingReconnect"] = 38] = "TryingReconnect";
    Translation[Translation["TypeToSearch"] = 39] = "TypeToSearch";
    Translation[Translation["Typing"] = 40] = "Typing";
    Translation[Translation["Unmute"] = 41] = "Unmute";
    Translation[Translation["ViewChat"] = 42] = "ViewChat";
    Translation[Translation["Yes"] = 43] = "Yes";
})(Translation || (Translation = {}));
/* tslint:disable:max-line-length */
export var locales = (_a = {},
    _a[Language.English] = (_b = {},
        _b[Translation.ChatEnded] = "The chat has ended.",
        _b[Translation.ChangeLanguage] = "Change Language",
        _b[Translation.SurveyThanks] = "Thanks for your feedback.",
        _b[Translation.Unmute] = "Unmute notification sounds",
        _b[Translation.OpenChat] = "Open Chat Support",
        _b[Translation.Error] = "Error",
        _b[Translation.BlockedAttachmentMessage] = "Please enable pop-ups in your browser to view this attachment.",
        _b[Translation.RequestTranscriptButton] = "Email Transcript",
        _b[Translation.Cancel] = "Cancel",
        _b[Translation.Submit] = "Submit",
        _b[Translation.RequestTranscriptModalTitle] = "Request Transcript",
        _b[Translation.FormError] = "Please fix the errors on the form to continue.",
        _b[Translation.EndChatModalMessage] = "Are you sure you want to end the chat?",
        _b[Translation.ViewChat] = "View Transcript",
        _b[Translation.Typing] = "typing",
        _b[Translation.ErrorInvalid] = "Invalid",
        _b[Translation.TranscriptRequested] = "Transcript Requested",
        _b[Translation.RequestTranscriptEmailLabel] = "Your email address",
        _b[Translation.Yes] = "Yes",
        _b[Translation.BlockedAttachmentTitle] = "Attachments Blocked",
        _b[Translation.AgentIsTyping] = "The agent is typing...",
        _b[Translation.EndChatButton] = "End Chat",
        _b[Translation.SkipSurvey] = "Skip Feedback",
        _b[Translation.ErrorRequired] = "Required",
        _b[Translation.NewChat] = "New Chat",
        _b[Translation.GoToSurvey] = "Rate Your Experience",
        _b[Translation.ChatInputPlaceholder] = "Your message...",
        _b[Translation.Mute] = "Mute notification sounds",
        _b[Translation.FinishedChatMoreOptions] = "More Options",
        _b[Translation.EmailTranscript] = "Email Transcript",
        _b[Translation.PrintTranscriptButton] = "Print Transcript",
        _b[Translation.CloseWindow] = "Close chat window",
        _b[Translation.Title] = "Help",
        _b[Translation.TooEarly] = "Too early",
        _b[Translation.TooLate] = "Too late",
        _b[Translation.TryingReconnect] = "Trying to reconnect",
        _b[Translation.Back] = "Back",
        _b[Translation.StartChat] = "Start Chat",
        _b[Translation.EndChatModalTitle] = "End Chat",
        _b[Translation.MinimiseWindow] = "Minimise Chat Window",
        _b[Translation.PrintTranscriptButton] = "Print Transcript",
        _b[Translation.DownloadTranscriptButton] = "Download Transcript",
        _b[Translation.EmptySelect] = "Nothing selected",
        _b[Translation.NoItemsFound] = "No results found",
        _b[Translation.TypeToSearch] = "Search...",
        _b),
    _a[Language.German] = (_c = {},
        _c[Translation.ChatEnded] = "Der Chat wurde beendet.",
        _c[Translation.ChangeLanguage] = "Sprache ändern",
        _c[Translation.SurveyThanks] = "Vielen Dank für Ihr Feedback.",
        _c[Translation.Unmute] = "Stummschaltung der Benachrichtigungen aufheben",
        _c[Translation.OpenChat] = "Chat Support öffnen",
        _c[Translation.Error] = "Fehler",
        _c[Translation.BlockedAttachmentMessage] = "Bitte aktivieren Sie Pop-ups in Ihrem Browser, um diesen Anhang anzuzeigen.",
        _c[Translation.RequestTranscriptButton] = "Email Transkript",
        _c[Translation.Cancel] = "Nein",
        _c[Translation.Submit] = "Einreichen",
        _c[Translation.RequestTranscriptModalTitle] = "Transkript anfordern",
        _c[Translation.FormError] = "Bitte korrigieren Sie die Fehler im Formular um fortzufahren.",
        _c[Translation.EndChatModalMessage] = "Sind Sie sicher, dass Sie den Chat beenden möchten?",
        _c[Translation.ViewChat] = "Transkript anzeigen",
        _c[Translation.Typing] = "Schreibt",
        _c[Translation.ErrorInvalid] = "Ungültig",
        _c[Translation.TranscriptRequested] = "Transkript angefordert",
        _c[Translation.RequestTranscriptEmailLabel] = "Deine Emailadresse",
        _c[Translation.Yes] = "Ja",
        _c[Translation.BlockedAttachmentTitle] = "Anhänge blockiert",
        _c[Translation.AgentIsTyping] = "Der Mitarbeiter schreibt...",
        _c[Translation.EndChatButton] = "Chat beenden",
        _c[Translation.SkipSurvey] = "Umfrage überspringen",
        _c[Translation.ErrorRequired] = "Erforderlich",
        _c[Translation.NewChat] = "Neuer Chat",
        _c[Translation.GoToSurvey] = "Bewerten Sie Ihre Erfahrung",
        _c[Translation.ChatInputPlaceholder] = "Ihre Nachricht",
        _c[Translation.Mute] = "Benachrichtigungen stummschalten",
        _c[Translation.FinishedChatMoreOptions] = "Weitere Optionen",
        _c[Translation.EmailTranscript] = "E-Mail Kopie des Chats",
        _c[Translation.CloseWindow] = "Close chat window",
        _c[Translation.Title] = "Hilfe",
        _c[Translation.TooEarly] = "Ungültig",
        _c[Translation.TooLate] = "Ungültig",
        _c[Translation.TryingReconnect] = "Verbindung wird wiederhergestellt",
        _c[Translation.Back] = "Zurück",
        _c[Translation.StartChat] = "Chat starten",
        _c[Translation.EndChatModalTitle] = "Chat beenden",
        _c[Translation.MinimiseWindow] = "Chat Fenster minimieren",
        _c[Translation.PrintTranscriptButton] = "Protokoll ausdrucken",
        _c[Translation.DownloadTranscriptButton] = "Protokoll herunterladen",
        _c[Translation.EmptySelect] = "Keine Auswahl getätigt",
        _c[Translation.NoItemsFound] = "Keine Ergebnisse gefunden",
        _c[Translation.TypeToSearch] = "Suchen...",
        _c),
    _a[Language.Spanish] = (_d = {},
        _d[Translation.ChatEnded] = "El chat ha finalizado.",
        _d[Translation.ChangeLanguage] = "Cambiar idioma",
        _d[Translation.SurveyThanks] = "Gracias por su opinión.",
        _d[Translation.Unmute] = "Activar notificaciones",
        _d[Translation.OpenChat] = "Inicar chat de soporte",
        _d[Translation.Error] = "Error",
        _d[Translation.BlockedAttachmentMessage] = "Habilite las ventanas emergentes en su navegador para poder ver este archivo adjunto.",
        _d[Translation.RequestTranscriptButton] = "Enviar Transcripción",
        _d[Translation.Cancel] = "Cancelar",
        _d[Translation.Submit] = "Enviar",
        _d[Translation.RequestTranscriptModalTitle] = "Solicitar Transcripción",
        _d[Translation.FormError] = "Por favor, solucione los errores en el formulario para continuar",
        _d[Translation.EndChatModalMessage] = "¿Está seguro de que quiere finalizar el chat?",
        _d[Translation.ViewChat] = "Ver Transcripción",
        _d[Translation.Typing] = "Escribiendo",
        _d[Translation.ErrorInvalid] = "Inválido",
        _d[Translation.TranscriptRequested] = "Transcripción Solicitada",
        _d[Translation.RequestTranscriptEmailLabel] = "Su dirección de correo electrónico",
        _d[Translation.Yes] = "Sí",
        _d[Translation.BlockedAttachmentTitle] = "Archivos Adjuntos Bloqueados",
        _d[Translation.AgentIsTyping] = "El agente está escribiendo...",
        _d[Translation.EndChatButton] = "Terminar chat",
        _d[Translation.SkipSurvey] = "Ignorar encuesta",
        _d[Translation.ErrorRequired] = "Necesario",
        _d[Translation.NewChat] = "Nuevo Chat",
        _d[Translation.GoToSurvey] = "Valore su experiencia",
        _d[Translation.ChatInputPlaceholder] = "Tu mensaje...",
        _d[Translation.Mute] = "Silenciar notificaciones",
        _d[Translation.FinishedChatMoreOptions] = "Más opciones",
        _d[Translation.EmailTranscript] = "Transcripción del correo electrónico",
        _d[Translation.CloseWindow] = "Close chat window",
        _d[Translation.Title] = "Ayuda",
        _d[Translation.TooEarly] = "Inválido",
        _d[Translation.TooLate] = "Inválido",
        _d[Translation.TryingReconnect] = "Intentando reconectar",
        _d[Translation.Back] = "Atrás",
        _d[Translation.StartChat] = "Comenzar chat",
        _d[Translation.EndChatModalTitle] = "Finalizar Chat",
        _d[Translation.MinimiseWindow] = "Minimizar la venta del chat",
        _d[Translation.PrintTranscriptButton] = "Imprimir transcripción",
        _d[Translation.DownloadTranscriptButton] = "Descargar transcripción",
        _d[Translation.EmptySelect] = "Nada seleccionado",
        _d[Translation.NoItemsFound] = "No se han encontrado resultados",
        _d[Translation.TypeToSearch] = "Búsqueda...",
        _d),
    _a[Language.Italian] = (_e = {},
        _e[Translation.ChatEnded] = "La chat é terminata",
        _e[Translation.ChangeLanguage] = "Cambia lingua",
        _e[Translation.SurveyThanks] = "La ringraziamo per il suo feedback.",
        _e[Translation.Unmute] = "Attiva l'audio delle notifiche",
        _e[Translation.OpenChat] = "Apri chat di supporto",
        _e[Translation.Error] = "Errore",
        _e[Translation.BlockedAttachmentMessage] = "Per favore, abiliti pop-ups nel suo browser per visualizzare questo allegato.",
        _e[Translation.RequestTranscriptButton] = "Inviare Trascrizione",
        _e[Translation.Cancel] = "Cancella",
        _e[Translation.Submit] = "Invia",
        _e[Translation.RequestTranscriptModalTitle] = "Richiedi Trascrizione",
        _e[Translation.FormError] = "Per favore, correggi gli errori sul modulo per continuare",
        _e[Translation.EndChatModalMessage] = "É sicuro di voler terminare questa chat?",
        _e[Translation.ViewChat] = "Vedi trascrizione",
        _e[Translation.Typing] = "Scrivendo",
        _e[Translation.ErrorInvalid] = "Invalido",
        _e[Translation.TranscriptRequested] = "Trascrizione Richiesta",
        _e[Translation.RequestTranscriptEmailLabel] = "Il tuo indirizzo email",
        _e[Translation.Yes] = "Si",
        _e[Translation.BlockedAttachmentTitle] = "Allegati bloccati",
        _e[Translation.AgentIsTyping] = "L'operatore sta scrivendo...",
        _e[Translation.EndChatButton] = "Chiudi chat",
        _e[Translation.SkipSurvey] = "Salta il sondaggio",
        _e[Translation.ErrorRequired] = "Richiesto",
        _e[Translation.NewChat] = "Nuova chat",
        _e[Translation.GoToSurvey] = "Valora la sua esperienza",
        _e[Translation.ChatInputPlaceholder] = "Il tuo messaggio...",
        _e[Translation.Mute] = "Disattiva l'audio delle notifiche",
        _e[Translation.FinishedChatMoreOptions] = "Altre opzioni",
        _e[Translation.EmailTranscript] = "Chat trascritta via email",
        _e[Translation.CloseWindow] = "Close chat window",
        _e[Translation.Title] = "Aiuto",
        _e[Translation.TooEarly] = "Invalido",
        _e[Translation.TooLate] = "Invalido",
        _e[Translation.TryingReconnect] = "Riconnessione in corso",
        _e[Translation.Back] = "Indietro",
        _e[Translation.StartChat] = "Inizia la chat",
        _e[Translation.EndChatModalTitle] = "Termina chat",
        _e[Translation.MinimiseWindow] = "Riduci la chat",
        _e[Translation.PrintTranscriptButton] = "Stampa trascrizione",
        _e[Translation.DownloadTranscriptButton] = "Scarica trascrizione",
        _e[Translation.EmptySelect] = "Niente selezionato",
        _e[Translation.NoItemsFound] = "Nessun risultato trovato",
        _e[Translation.TypeToSearch] = "Cerca...",
        _e),
    _a[Language.French] = (_f = {},
        _f[Translation.ChatEnded] = "Le chat est terminé",
        _f[Translation.ChangeLanguage] = "Changement de langue",
        _f[Translation.SurveyThanks] = "Merci pour vos commentaires.",
        _f[Translation.Unmute] = "Réactiver le son des notifications",
        _f[Translation.OpenChat] = "Ouverture du chat",
        _f[Translation.Error] = "Erreur",
        _f[Translation.BlockedAttachmentMessage] = "Veuillez activer les 'pop-ups' dans votre navigateur pour afficher cette pièce jointe.",
        _f[Translation.RequestTranscriptButton] = "Envoyer Transcription",
        _f[Translation.Cancel] = "Annuler",
        _f[Translation.Submit] = "Soumettre",
        _f[Translation.RequestTranscriptModalTitle] = "Demande de Transcription",
        _f[Translation.FormError] = "S'il vous plaît veuillez corriger l'erreur afin de continuer",
        _f[Translation.EndChatModalMessage] = "Êtes-vous sûr de vouloir mettre fin à ce chat?",
        _f[Translation.ViewChat] = "Voir Transcription",
        _f[Translation.Typing] = "En train d'écrire",
        _f[Translation.ErrorInvalid] = "Erreur/ Pas valide",
        _f[Translation.TranscriptRequested] = "Transcription demandée",
        _f[Translation.RequestTranscriptEmailLabel] = "Votre adresse email",
        _f[Translation.Yes] = "Oui",
        _f[Translation.BlockedAttachmentTitle] = "Pièces jointes bloquées",
        _f[Translation.AgentIsTyping] = "L'agent est en train d'écrire",
        _f[Translation.EndChatButton] = "Terminer le chat",
        _f[Translation.SkipSurvey] = "Passer enquête de satisfaction",
        _f[Translation.ErrorRequired] = "Requis",
        _f[Translation.NewChat] = "Nouveau Chat",
        _f[Translation.GoToSurvey] = "Évaluez votre experience",
        _f[Translation.ChatInputPlaceholder] = "Votre texte...",
        _f[Translation.Mute] = "Désactiver le son des notifications",
        _f[Translation.FinishedChatMoreOptions] = "Plus d'options",
        _f[Translation.EmailTranscript] = "Transcription par email",
        _f[Translation.CloseWindow] = "Close chat window",
        _f[Translation.Title] = "Aidez-moi",
        _f[Translation.TooEarly] = "Erreur/ Pas valide",
        _f[Translation.TooLate] = "Erreur/ Pas valide",
        _f[Translation.TryingReconnect] = "On essaye de vous reconnecter",
        _f[Translation.Back] = "Revenier en arrière",
        _f[Translation.StartChat] = "Commencer le chat",
        _f[Translation.EndChatModalTitle] = "Terminer le chat",
        _f[Translation.MinimiseWindow] = "Réduire le chat",
        _f[Translation.PrintTranscriptButton] = "Enquête",
        _f[Translation.DownloadTranscriptButton] = "Télécharger le script",
        _f[Translation.EmptySelect] = "Rien n'a été sélectionné",
        _f[Translation.NoItemsFound] = "Aucun résultat n'a été trouvé",
        _f[Translation.TypeToSearch] = "Rechercher...",
        _f),
    _a[Language.Dutch] = (_g = {},
        _g[Translation.ChatEnded] = "De chat is beëindigd.",
        _g[Translation.ChangeLanguage] = "Verander taal",
        _g[Translation.SurveyThanks] = "Bedankt voor uw feedback.",
        _g[Translation.Unmute] = "Demping van meldingsgeluiden opheffen",
        _g[Translation.OpenChat] = "Open chat venster",
        _g[Translation.Error] = "Fout",
        _g[Translation.BlockedAttachmentMessage] = "Laat pop-ups toe in uw browser om deze bijlagen te bekijken.",
        _g[Translation.RequestTranscriptButton] = "Email transcript",
        _g[Translation.Cancel] = "Annulleren",
        _g[Translation.Submit] = "Verzenden",
        _g[Translation.RequestTranscriptModalTitle] = "Vraag transcript aan",
        _g[Translation.FormError] = "Corrigeer aub de fouten op het formulier om door te gaan.",
        _g[Translation.EndChatModalMessage] = "Weet u zeker dat u de chat wilt beëindigen?",
        _g[Translation.ViewChat] = "Bekijk transcript",
        _g[Translation.Typing] = "Aan het typen",
        _g[Translation.ErrorInvalid] = "Ongeldig",
        _g[Translation.TranscriptRequested] = "Transcript aangevraagd",
        _g[Translation.RequestTranscriptEmailLabel] = "Uw emailadres",
        _g[Translation.Yes] = "Ja",
        _g[Translation.BlockedAttachmentTitle] = "Bijlagen geblokkeerd",
        _g[Translation.AgentIsTyping] = "De medewerker typt...",
        _g[Translation.EndChatButton] = "Beëindig chat",
        _g[Translation.SkipSurvey] = "Sla feedback over",
        _g[Translation.ErrorRequired] = "Verplicht",
        _g[Translation.NewChat] = "Nieuwe chat",
        _g[Translation.GoToSurvey] = "Beoordeel uw ervaring",
        _g[Translation.ChatInputPlaceholder] = "Uw bericht ...",
        _g[Translation.Mute] = "Mute-meldingsgeluiden",
        _g[Translation.FinishedChatMoreOptions] = "Meer opties",
        _g[Translation.EmailTranscript] = "Email transcript",
        _g[Translation.CloseWindow] = "Close chat window",
        _g[Translation.Title] = "Help",
        _g[Translation.TooEarly] = "Ongeldig",
        _g[Translation.TooLate] = "Ongeldig",
        _g[Translation.TryingReconnect] = "Probeert opnieuw te verbinden",
        _g[Translation.Back] = "Terug",
        _g[Translation.StartChat] = "Begin chat",
        _g[Translation.EndChatModalTitle] = "Chat eindigen",
        _g[Translation.MinimiseWindow] = "Verklein chat venster",
        _g[Translation.PrintTranscriptButton] = "Transcript printen",
        _g[Translation.DownloadTranscriptButton] = "Transcript downloaden",
        _g[Translation.EmptySelect] = "Niets geselecteerd",
        _g[Translation.NoItemsFound] = "Geen resultaten gevonden",
        _g[Translation.TypeToSearch] = "Zoeken…",
        _g),
    _a[Language.Swedish] = (_h = {},
        _h[Translation.ChatEnded] = "Denna Chatt har avslutats",
        _h[Translation.ChangeLanguage] = "Ändra språk",
        _h[Translation.SurveyThanks] = "Tack för din feedback.",
        _h[Translation.Unmute] = "Sätt på notifikationssignalen",
        _h[Translation.OpenChat] = "Öppna Chat Support",
        _h[Translation.Error] = "Fel",
        _h[Translation.BlockedAttachmentMessage] = "Aktivera popup-fönster i din webbläsare för att se den här bilagan",
        _h[Translation.RequestTranscriptButton] = "Skicka transkript via epost",
        _h[Translation.Cancel] = "Annullera",
        _h[Translation.Submit] = "Bekräfta",
        _h[Translation.RequestTranscriptModalTitle] = "Begär transkript",
        _h[Translation.FormError] = "Fixa felen på formuläret för att fortsätta.",
        _h[Translation.EndChatModalMessage] = "Är du säker på att du vill avsluta Chatten?",
        _h[Translation.ViewChat] = "Se transkript",
        _h[Translation.Typing] = "Skriver",
        _h[Translation.ErrorInvalid] = "Ogiltig",
        _h[Translation.TranscriptRequested] = "Transkript har begärts",
        _h[Translation.RequestTranscriptEmailLabel] = "Din epost adress",
        _h[Translation.Yes] = "Ja",
        _h[Translation.BlockedAttachmentTitle] = "Bilagor blockerade",
        _h[Translation.AgentIsTyping] = "Agenten skriver ...",
        _h[Translation.EndChatButton] = "Avsluta Chatten",
        _h[Translation.SkipSurvey] = "Skippa Feedback",
        _h[Translation.ErrorRequired] = "Nödvändig",
        _h[Translation.NewChat] = "Ny Chatt",
        _h[Translation.GoToSurvey] = "Betygsätta din upplevelse",
        _h[Translation.ChatInputPlaceholder] = "Ditt meddelande",
        _h[Translation.Mute] = "Sätt notifikationssignalen på ljudlös",
        _h[Translation.FinishedChatMoreOptions] = "Fler alternativ",
        _h[Translation.EmailTranscript] = "Chatt transkript",
        _h[Translation.CloseWindow] = "Close chat window",
        _h[Translation.Title] = "Hjälp",
        _h[Translation.TooEarly] = "Ogiltig",
        _h[Translation.TooLate] = "Ogiltig",
        _h[Translation.TryingReconnect] = "Försöker återansluta",
        _h[Translation.Back] = "Tillbaka",
        _h[Translation.StartChat] = "Starta chatt",
        _h[Translation.EndChatModalTitle] = "Avlsuta Chatt",
        _h[Translation.MinimiseWindow] = "Minimera chattfönstret",
        _h[Translation.PrintTranscriptButton] = "Printa kopia",
        _h[Translation.DownloadTranscriptButton] = "Ladda ner kopia",
        _h[Translation.EmptySelect] = "Inget valt",
        _h[Translation.NoItemsFound] = "Inga resultat funna",
        _h[Translation.TypeToSearch] = "Sök...",
        _h),
    _a[Language.Polish] = (_j = {},
        _j[Translation.ChatEnded] = "Czat zakonczony",
        _j[Translation.ChangeLanguage] = "Zmien jezyk",
        _j[Translation.SurveyThanks] = "Dziekujemy za feedback",
        _j[Translation.Unmute] = "Wlacz dzwieki powiadomien",
        _j[Translation.OpenChat] = "Otworz Czat",
        _j[Translation.Error] = "Blad",
        _j[Translation.BlockedAttachmentMessage] = "Prosze wlaczyc pop-upy w przrgladarce aby zobaczyc ten zalacznik.",
        _j[Translation.RequestTranscriptButton] = "Zapis emaila",
        _j[Translation.Cancel] = "Anuluj",
        _j[Translation.Submit] = "Zatwierdz",
        _j[Translation.RequestTranscriptModalTitle] = "Popros o zapis",
        _j[Translation.FormError] = "Aby kontynuowac, prosimy poprawic bledy w formularzu",
        _j[Translation.EndChatModalMessage] = "Czy na pewno chcesz zakonczyc czat?",
        _j[Translation.ViewChat] = "Zobacz zapis czatu",
        _j[Translation.Typing] = "Pisze wiadomosc",
        _j[Translation.ErrorInvalid] = "Niewazny",
        _j[Translation.TranscriptRequested] = "Wyspanie zapytania o zapis",
        _j[Translation.RequestTranscriptEmailLabel] = "Twoj email",
        _j[Translation.Yes] = "Tak",
        _j[Translation.BlockedAttachmentTitle] = "Zalaczniki zablokowane",
        _j[Translation.AgentIsTyping] = "Agent pisze wiadomosc...",
        _j[Translation.EndChatButton] = "Zakoncz czat",
        _j[Translation.SkipSurvey] = "Omin feedback",
        _j[Translation.ErrorRequired] = "Wymagany",
        _j[Translation.NewChat] = "Nowy czat",
        _j[Translation.GoToSurvey] = "Podziel się opinią",
        _j[Translation.ChatInputPlaceholder] = "Twoja wiadomosc...",
        _j[Translation.Mute] = "Wycisz dzwieki powiadomien",
        _j[Translation.FinishedChatMoreOptions] = "Więcej opcji",
        _j[Translation.EmailTranscript] = "Zapis emaila",
        _j[Translation.CloseWindow] = "Close chat window",
        _j[Translation.Title] = "Pomoc",
        _j[Translation.TooEarly] = "Niewazny",
        _j[Translation.TooLate] = "Niewazny",
        _j[Translation.TryingReconnect] = "Uzyskiwanie polaczenie",
        _j[Translation.Back] = "Wstecz",
        _j[Translation.StartChat] = "Rozpocznij czat",
        _j[Translation.EndChatModalTitle] = "Zakoncz czas",
        _j[Translation.MinimiseWindow] = "Zminimalizuj okno czatu",
        _j[Translation.PrintTranscriptButton] = "Wydrukuj tranksrypcję",
        _j[Translation.DownloadTranscriptButton] = "Pobierz transkrypcję",
        _j[Translation.EmptySelect] = "Nie wybrano żadnej opcji.",
        _j[Translation.NoItemsFound] = "Brak wyników wyszukiwania. ",
        _j[Translation.TypeToSearch] = "Szukaj...",
        _j),
    _a[Language.Russian] = (_k = {},
        _k[Translation.ChatEnded] = "Чат закончен",
        _k[Translation.ChangeLanguage] = "Изменить язык",
        _k[Translation.SurveyThanks] = "Спасибо за Ваш отзыв",
        _k[Translation.Unmute] = "Включить звук уведомлений",
        _k[Translation.OpenChat] = "Открыть чат",
        _k[Translation.Error] = "Ошибка",
        _k[Translation.BlockedAttachmentMessage] = "Пожалуйста, включите появляющиеся окна в Вашем браузере, чтобы просмотреть эти вложения",
        _k[Translation.RequestTranscriptButton] = "Выслать стенограмму на электронный адрес",
        _k[Translation.Cancel] = "Отменить",
        _k[Translation.Submit] = "Отправить",
        _k[Translation.RequestTranscriptModalTitle] = "Запросить стенограмму",
        _k[Translation.FormError] = "Пожалуйста, исправьте ошибки в форме, чтобы продолжить.",
        _k[Translation.EndChatModalMessage] = "Вы действительно хотите закончить чат?",
        _k[Translation.ViewChat] = "Смотреть стенограмму",
        _k[Translation.Typing] = "Написание",
        _k[Translation.ErrorInvalid] = "Недействительно",
        _k[Translation.TranscriptRequested] = "Стенограмма запрошена",
        _k[Translation.RequestTranscriptEmailLabel] = "Адрес Вашей электронной почты",
        _k[Translation.Yes] = "Да",
        _k[Translation.BlockedAttachmentTitle] = "Вложения заблокированы",
        _k[Translation.AgentIsTyping] = "Агент печатает",
        _k[Translation.EndChatButton] = "Кнопка завершения чата",
        _k[Translation.SkipSurvey] = "Пропустить отзыв",
        _k[Translation.ErrorRequired] = "Обязательно",
        _k[Translation.NewChat] = "Новый чат",
        _k[Translation.GoToSurvey] = "Оцените ваш опыт",
        _k[Translation.ChatInputPlaceholder] = "Заполнитель чата",
        _k[Translation.Mute] = "Выключить звук уведомлений",
        _k[Translation.FinishedChatMoreOptions] = "Другие варианты",
        _k[Translation.EmailTranscript] = "Выслать стенограмму на электронный адрес",
        _k[Translation.CloseWindow] = "Close chat window",
        _k[Translation.Title] = "Помощь",
        _k[Translation.TooEarly] = "Недействительно",
        _k[Translation.TooLate] = "Недействительно",
        _k[Translation.TryingReconnect] = "Попытка соединения",
        _k[Translation.Back] = "Назад",
        _k[Translation.StartChat] = "Начать чат",
        _k[Translation.EndChatModalTitle] = "Закончить чат",
        _k[Translation.MinimiseWindow] = "Свернуть окно",
        _k[Translation.PrintTranscriptButton] = "Распечатка стенограммы",
        _k[Translation.DownloadTranscriptButton] = "Скачать стенограмму",
        _k[Translation.EmptySelect] = "Ничего не выбрано",
        _k[Translation.NoItemsFound] = "Результаты не найдены",
        _k[Translation.TypeToSearch] = "Поиск…",
        _k),
    _a[Language.Portuguese] = (_l = {},
        _l[Translation.ChatEnded] = "O chat terminou",
        _l[Translation.ChangeLanguage] = "Trocar língua",
        _l[Translation.SurveyThanks] = "Obrigado pelo seu feedback",
        _l[Translation.Unmute] = "Ativar sons the notificacao",
        _l[Translation.OpenChat] = "Abrir Suporte por Chat",
        _l[Translation.Error] = "Erro",
        _l[Translation.BlockedAttachmentMessage] = "Por favor, habilite os pop-ups em seu navegador para ver este anexo.",
        _l[Translation.RequestTranscriptButton] = "Transcricao de email",
        _l[Translation.Cancel] = "Cancelar",
        _l[Translation.Submit] = "Enviar",
        _l[Translation.RequestTranscriptModalTitle] = "Solicitar transcricao",
        _l[Translation.FormError] = "Por favor, corrija os erros no formulário para continuar.",
        _l[Translation.EndChatModalMessage] = "Voce tem certeza que deseja finalizar o chat?",
        _l[Translation.ViewChat] = "Ver transcricao do chat",
        _l[Translation.Typing] = "Digitando",
        _l[Translation.ErrorInvalid] = "Erro/Invalido",
        _l[Translation.TranscriptRequested] = "Transcricao solicitada",
        _l[Translation.RequestTranscriptEmailLabel] = "Seu endereco de email",
        _l[Translation.Yes] = "Sim",
        _l[Translation.BlockedAttachmentTitle] = "Anexo bloqueado",
        _l[Translation.AgentIsTyping] = "Agenten skriver...",
        _l[Translation.EndChatButton] = "Terminar Chat",
        _l[Translation.SkipSurvey] = "Pular feedback",
        _l[Translation.ErrorRequired] = "Erro/Obrigatorio",
        _l[Translation.NewChat] = "Novo chat",
        _l[Translation.GoToSurvey] = "Avalie sua experiência",
        _l[Translation.ChatInputPlaceholder] = "Sua mensagem...",
        _l[Translation.Mute] = "Silenciar sons the notificacao",
        _l[Translation.FinishedChatMoreOptions] = "Mais opções",
        _l[Translation.EmailTranscript] = "Transcricao de email",
        _l[Translation.CloseWindow] = "Close chat window",
        _l[Translation.Title] = "Ajuda",
        _l[Translation.TooEarly] = "Erro/Invalido",
        _l[Translation.TooLate] = "Erro/Invalido",
        _l[Translation.TryingReconnect] = "Tentando reconectar",
        _l[Translation.Back] = "Voltar",
        _l[Translation.StartChat] = "Iniciar bate-papo",
        _l[Translation.EndChatModalTitle] = "Fim do chat",
        _l[Translation.MinimiseWindow] = "Minimizar a janela do Chat",
        _l[Translation.PrintTranscriptButton] = "Imprimir a transcrição.",
        _l[Translation.DownloadTranscriptButton] = "Baixar a transcrição.",
        _l[Translation.EmptySelect] = "Nenhum criterio foi seleccionado",
        _l[Translation.NoItemsFound] = "Sem resultado",
        _l[Translation.TypeToSearch] = "Procurar...",
        _l),
    _a[Language.Norwegian] = (_m = {},
        _m[Translation.ChatEnded] = "Chatten er avsluttet.",
        _m[Translation.ChangeLanguage] = "Endre språk",
        _m[Translation.SurveyThanks] = "Takk for din tilbakemelding.",
        _m[Translation.Unmute] = "Slå av lyden for varsling",
        _m[Translation.OpenChat] = "Åpne Chat Support",
        _m[Translation.Error] = "Feil",
        _m[Translation.BlockedAttachmentMessage] = "Vennligst tillatt pop-ups i din nettleser for å se vedlegget.",
        _m[Translation.RequestTranscriptButton] = "Send kopi på e-post",
        _m[Translation.Cancel] = "Kanseller",
        _m[Translation.Submit] = "Send",
        _m[Translation.RequestTranscriptModalTitle] = "Be om kopi",
        _m[Translation.FormError] = "Vennligst fiks feilen i skjemaet for å fortsette",
        _m[Translation.EndChatModalMessage] = "Er du sikker på at du vil avslutte chatten?",
        _m[Translation.ViewChat] = "Se kopi av Chat",
        _m[Translation.Typing] = "Skriver",
        _m[Translation.ErrorInvalid] = "Ikke Gyldig",
        _m[Translation.TranscriptRequested] = "Forespørsel om kopi sendt",
        _m[Translation.RequestTranscriptEmailLabel] = "Din e-post adresse",
        _m[Translation.Yes] = "Ja",
        _m[Translation.BlockedAttachmentTitle] = "Vedlegg blokkert",
        _m[Translation.AgentIsTyping] = "Agenten skriver...",
        _m[Translation.EndChatButton] = "Avslutt Chatten",
        _m[Translation.SkipSurvey] = "Hopp Over Tilbakemelding",
        _m[Translation.ErrorRequired] = "Nødvendig",
        _m[Translation.NewChat] = "Ny Chat",
        _m[Translation.GoToSurvey] = "Vurder din opplevelse",
        _m[Translation.ChatInputPlaceholder] = "Din melding",
        _m[Translation.Mute] = "Dempende varsling lyder",
        _m[Translation.FinishedChatMoreOptions] = "Flere alternativ",
        _m[Translation.EmailTranscript] = "Send kopi på e-post",
        _m[Translation.CloseWindow] = "Close chat window",
        _m[Translation.Title] = "Hjelp",
        _m[Translation.TooEarly] = "Ikke Gyldig",
        _m[Translation.TooLate] = "Ikke Gyldig",
        _m[Translation.TryingReconnect] = "Forsøker å koble til igjen",
        _m[Translation.Back] = "Tilbake",
        _m[Translation.StartChat] = "Start chat",
        _m[Translation.EndChatModalTitle] = "Avslutt Chat",
        _m[Translation.MinimiseWindow] = "Minimer chatvinduet",
        _m[Translation.PrintTranscriptButton] = "Print kopi",
        _m[Translation.DownloadTranscriptButton] = "Last ned kopi",
        _m[Translation.EmptySelect] = "Ingenting valgt",
        _m[Translation.NoItemsFound] = "Fant ingen resultater",
        _m[Translation.TypeToSearch] = "Søk...",
        _m),
    _a[Language.Turkish] = (_o = {},
        _o[Translation.ChatEnded] = "Chat sona erdi.",
        _o[Translation.ChangeLanguage] = "Dili Değiştir",
        _o[Translation.SurveyThanks] = "Geri bildiriminiz için teşekkür ederiz.",
        _o[Translation.Unmute] = "Bildirim seslerini aç",
        _o[Translation.OpenChat] = "sohbet desteğini aç",
        _o[Translation.Error] = "Hata",
        _o[Translation.BlockedAttachmentMessage] = "Bu eki görüntülemek için lütfen tarayıcınızdaki açılır pencereleri etkinleştirin.",
        _o[Translation.RequestTranscriptButton] = "Transkript İste",
        _o[Translation.Cancel] = "İptal",
        _o[Translation.Submit] = "Onayla",
        _o[Translation.RequestTranscriptModalTitle] = "Transkript İste",
        _o[Translation.FormError] = "Devam etmek için lütfen formdaki hataları düzeltin",
        _o[Translation.EndChatModalMessage] = "Sohbeti bitirmek istediğinize emin misiniz?",
        _o[Translation.ViewChat] = "Sohbeti Göster",
        _o[Translation.Typing] = "Yazıyor",
        _o[Translation.ErrorInvalid] = "Geçersiz",
        _o[Translation.TranscriptRequested] = "Transkript Talep Edildi",
        _o[Translation.RequestTranscriptEmailLabel] = "E-post adresiniz",
        _o[Translation.Yes] = "Evet",
        _o[Translation.BlockedAttachmentTitle] = "Ek Blokelendi",
        _o[Translation.AgentIsTyping] = "Temsilci yazıyor...",
        _o[Translation.EndChatButton] = "Canlı Sohbeti Sonlandır",
        _o[Translation.SkipSurvey] = "Anketi Atla",
        _o[Translation.ErrorRequired] = "Gerekli",
        _o[Translation.NewChat] = "Yeni Sohbet",
        _o[Translation.GoToSurvey] = "Deneyiminizi değerlendirin",
        _o[Translation.ChatInputPlaceholder] = "Mesajınız...",
        _o[Translation.Mute] = "Bildirim sesini kapat",
        _o[Translation.FinishedChatMoreOptions] = "Daha fazla seçenek",
        _o[Translation.EmailTranscript] = "E-posta Transkripti",
        _o[Translation.CloseWindow] = "Close chat window",
        _o[Translation.Title] = "Yardım",
        _o[Translation.TooEarly] = "Geçersiz",
        _o[Translation.TooLate] = "Geçersiz",
        _o[Translation.TryingReconnect] = "Yeniden Bağlanıyor",
        _o[Translation.Back] = "Geri",
        _o[Translation.StartChat] = "Sohbeti başlat",
        _o[Translation.EndChatModalTitle] = "Sohbeti Sonlandır",
        _o[Translation.MinimiseWindow] = "Canlı Sohbet Penceresini Küçült",
        _o[Translation.PrintTranscriptButton] = "Transkripti Yazdır",
        _o[Translation.DownloadTranscriptButton] = "Transkripti İndir",
        _o[Translation.EmptySelect] = "Hiçbir şey seçilmedi",
        _o[Translation.NoItemsFound] = "Hiçbir sonuç bulunamadı",
        _o[Translation.TypeToSearch] = "Arama...",
        _o),
    _a[Language.Thai] = (_p = {},
        _p[Translation.ChatEnded] = "แชทได้สิ้นสุดลงแล้ว",
        _p[Translation.ChangeLanguage] = "เปลี่ยนภาษา",
        _p[Translation.SurveyThanks] = "ขอบคุณสำหรับความคิดเห็นของคุณ",
        _p[Translation.Unmute] = "เปิดเสียงปิดเสียงเตือน",
        _p[Translation.OpenChat] = "เปิดการสนับสนุนการแชท",
        _p[Translation.Error] = "ความผิดพลาด",
        _p[Translation.BlockedAttachmentMessage] = "โปรดเปิดใช้งานป๊อปอัพในเบราว์เซอร์ของคุณเพื่อดูสิ่งที่แนบมานี้",
        _p[Translation.RequestTranscriptButton] = "Transcript อีเมล์",
        _p[Translation.Cancel] = "ยกเลิก",
        _p[Translation.Submit] = "เสนอ",
        _p[Translation.RequestTranscriptModalTitle] = "ที่ขอ Transcript",
        _p[Translation.FormError] = "โปรดแก้ไขข้อผิดพลาดในแบบฟอร์มเพื่อดำเนินการต่อ",
        _p[Translation.EndChatModalMessage] = "คุณแน่ใจหรือไม่ว่าต้องการที่จะจบการสนทนา?",
        _p[Translation.ViewChat] = "ดู Transcript",
        _p[Translation.Typing] = "การพิมพ์",
        _p[Translation.ErrorInvalid] = "โมฆะ",
        _p[Translation.TranscriptRequested] = "Transcript ขอ",
        _p[Translation.RequestTranscriptEmailLabel] = "ที่อยู่อีเมลของคุณ",
        _p[Translation.Yes] = "ใช่",
        _p[Translation.BlockedAttachmentTitle] = "สิ่งที่แนบมา ถูกบล็อก",
        _p[Translation.AgentIsTyping] = "เจ้าหน้าที่กำลังพิมพ์...",
        _p[Translation.EndChatButton] = "ปิดแชต",
        _p[Translation.SkipSurvey] = "ข้ามการสำรวจ",
        _p[Translation.ErrorRequired] = "จำเป็นต้องใช้",
        _p[Translation.NewChat] = "แชทใหม่",
        _p[Translation.GoToSurvey] = "เรทประสบการณ์ของคุณ",
        _p[Translation.ChatInputPlaceholder] = "ข้อความของคุณ...",
        _p[Translation.Mute] = "ปิดเสียงการแจ้งเตือน",
        _p[Translation.FinishedChatMoreOptions] = "ข้อเลือกเพิ่มเติม",
        _p[Translation.EmailTranscript] = "Transcript อีเมล์",
        _p[Translation.CloseWindow] = "Close chat window",
        _p[Translation.Title] = "ช่วยด้วย",
        _p[Translation.TooEarly] = "โมฆะ",
        _p[Translation.TooLate] = "โมฆะ",
        _p[Translation.TryingReconnect] = "พยายามที่จะเชื่อมต่อ",
        _p[Translation.Back] = "กลับ",
        _p[Translation.StartChat] = "เริ่มแชทใหม่",
        _p[Translation.EndChatModalTitle] = "จบการพูดคุย",
        _p[Translation.MinimiseWindow] = "ปิดหน้าต่างแชต",
        _p[Translation.PrintTranscriptButton] = "พิมพ์ทรานสคริปต์",
        _p[Translation.DownloadTranscriptButton] = "ดาวน์โหลดทรานสคริปต์",
        _p[Translation.EmptySelect] = "ไม่ได้เลือกรายการใด",
        _p[Translation.NoItemsFound] = "ไม่พบผลการค้นหา",
        _p[Translation.TypeToSearch] = "ค้นหา...",
        _p),
    _a[Language.Bosnian] = (_q = {},
        _q[Translation.ChatEnded] = "Razgovor je završen",
        _q[Translation.ChangeLanguage] = "Promijenite jezik",
        _q[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _q[Translation.Unmute] = "Uključi zvukove obavijesti",
        _q[Translation.OpenChat] = "Podrška za otvoreni chat",
        _q[Translation.Error] = "Pogreška",
        _q[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _q[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _q[Translation.Cancel] = "Otkazati",
        _q[Translation.Submit] = "Podnijeti",
        _q[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _q[Translation.FormError] = "Ispravite greške na obrascu da biste nastavili",
        _q[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _q[Translation.ViewChat] = "Pogledaj prijepis",
        _q[Translation.Typing] = "Tipkanje",
        _q[Translation.ErrorInvalid] = "Nevažeći",
        _q[Translation.TranscriptRequested] = "Prijepis zatražen",
        _q[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _q[Translation.Yes] = "Da",
        _q[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _q[Translation.AgentIsTyping] = "Agent kuca...",
        _q[Translation.EndChatButton] = "Kraj chata",
        _q[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _q[Translation.ErrorRequired] = "Potreban",
        _q[Translation.NewChat] = "Novi razgovor",
        _q[Translation.GoToSurvey] = "Ocijenite Vaše iskustvo",
        _q[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _q[Translation.Mute] = "Priguši zvukove obavijesti",
        _q[Translation.FinishedChatMoreOptions] = "Više opcija",
        _q[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _q[Translation.CloseWindow] = "Close chat window",
        _q[Translation.Title] = "Pomoć",
        _q[Translation.TooEarly] = "Nevažeći",
        _q[Translation.TooLate] = "Nevažeći",
        _q[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _q[Translation.Back] = "Natrag",
        _q[Translation.StartChat] = "Započni razgovor",
        _q[Translation.EndChatModalTitle] = "Završetak razgovora",
        _q[Translation.MinimiseWindow] = "Smanjite prozor za chat",
        _q[Translation.PrintTranscriptButton] = "Print Transcript",
        _q[Translation.DownloadTranscriptButton] = "Download Transcript",
        _q[Translation.EmptySelect] = "Nothing selected",
        _q[Translation.NoItemsFound] = "No results found",
        _q[Translation.TypeToSearch] = "Search...",
        _q),
    _a[Language.Serbian] = (_r = {},
        _r[Translation.ChatEnded] = "Razgovor je završen",
        _r[Translation.ChangeLanguage] = "Promenite jezik",
        _r[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _r[Translation.Unmute] = "Uključi zvukove novosti",
        _r[Translation.OpenChat] = "Podrška za otvoreno časkanje",
        _r[Translation.Error] = "Pogreška",
        _r[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _r[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _r[Translation.Cancel] = "Otkazati",
        _r[Translation.Submit] = "Podnijeti",
        _r[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _r[Translation.FormError] = "Ispravite pogreške na obrascu da biste nastavili",
        _r[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _r[Translation.ViewChat] = "Pogledaj prijepis",
        _r[Translation.Typing] = "Tipkanje",
        _r[Translation.ErrorInvalid] = "Nevažeći",
        _r[Translation.TranscriptRequested] = "Prijepis zatražen",
        _r[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _r[Translation.Yes] = "Da",
        _r[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _r[Translation.AgentIsTyping] = "Agent kuca...",
        _r[Translation.EndChatButton] = "Kraj časkanja",
        _r[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _r[Translation.ErrorRequired] = "Potreban",
        _r[Translation.NewChat] = "Novi razgovor",
        _r[Translation.GoToSurvey] = "Ocenite Vaše iskustvo",
        _r[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _r[Translation.Mute] = "Priguši zvukove novosti",
        _r[Translation.FinishedChatMoreOptions] = "Više opcija",
        _r[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _r[Translation.CloseWindow] = "Close chat window",
        _r[Translation.Title] = "Pomoć",
        _r[Translation.TooEarly] = "Nevažeći",
        _r[Translation.TooLate] = "Nevažeći",
        _r[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _r[Translation.Back] = "Natrag",
        _r[Translation.StartChat] = "Započni razgovor",
        _r[Translation.EndChatModalTitle] = "Završetak razgovora",
        _r[Translation.MinimiseWindow] = "Minimizirajte prozor za časkanje",
        _r[Translation.PrintTranscriptButton] = "Print Transcript",
        _r[Translation.DownloadTranscriptButton] = "Download Transcript",
        _r[Translation.EmptySelect] = "Nothing selected",
        _r[Translation.NoItemsFound] = "No results found",
        _r[Translation.TypeToSearch] = "Search...",
        _r),
    _a[Language.Croatian] = (_s = {},
        _s[Translation.ChatEnded] = "Razgovor je završen",
        _s[Translation.ChangeLanguage] = "Promijenite jezik",
        _s[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _s[Translation.Unmute] = "Uključi zvukove obavijesti",
        _s[Translation.OpenChat] = "Podrška za otvoreni chat",
        _s[Translation.Error] = "Pogreška",
        _s[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _s[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _s[Translation.Cancel] = "Otkazati",
        _s[Translation.Submit] = "Podnijeti",
        _s[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _s[Translation.FormError] = "Ispravite greške na obrascu da biste nastavili",
        _s[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _s[Translation.ViewChat] = "Pogledaj prijepis",
        _s[Translation.Typing] = "Tipkanje",
        _s[Translation.ErrorInvalid] = "Nevažeći",
        _s[Translation.TranscriptRequested] = "Prijepis zatražen",
        _s[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _s[Translation.Yes] = "Da",
        _s[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _s[Translation.AgentIsTyping] = "Agent piše...",
        _s[Translation.EndChatButton] = "Završetak chata",
        _s[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _s[Translation.ErrorRequired] = "Potreban",
        _s[Translation.NewChat] = "Novi razgovor",
        _s[Translation.GoToSurvey] = "Ocijenite Vaše iskustvo",
        _s[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _s[Translation.Mute] = "Utišaj zvukove obavijesti",
        _s[Translation.FinishedChatMoreOptions] = "Više opcija",
        _s[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _s[Translation.CloseWindow] = "Close chat window",
        _s[Translation.Title] = "Pomoć",
        _s[Translation.TooEarly] = "Nevažeći",
        _s[Translation.TooLate] = "Nevažeći",
        _s[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _s[Translation.Back] = "Natrag",
        _s[Translation.StartChat] = "Započni razgovor",
        _s[Translation.EndChatModalTitle] = "Završetak razgovora",
        _s[Translation.MinimiseWindow] = "Smanjite prozor za chat",
        _s[Translation.PrintTranscriptButton] = "Printaj prepisku",
        _s[Translation.DownloadTranscriptButton] = "Skini prepisku",
        _s[Translation.EmptySelect] = "Ništa nije odabrano",
        _s[Translation.NoItemsFound] = "Nisu pronađeni rezultati",
        _s[Translation.TypeToSearch] = "Pretražite...",
        _s),
    _a[Language.Romanian] = (_t = {},
        _t[Translation.ChatEnded] = "Chat-ul s-a încheiat.",
        _t[Translation.ChangeLanguage] = "Modificați limba",
        _t[Translation.SurveyThanks] = "Vă mulțumim pentru feedback-ul dumneavoastră.",
        _t[Translation.Unmute] = "Se anulează sunetele de notificare",
        _t[Translation.OpenChat] = "Deschideți Chat Support",
        _t[Translation.Error] = "Eroare",
        _t[Translation.BlockedAttachmentMessage] = "Activați opțiunea pop-up în browserul dvs. pentru a vizualiza acest atașament.",
        _t[Translation.RequestTranscriptButton] = "Trimite transcrierea pe e-mail",
        _t[Translation.Cancel] = "Anulează",
        _t[Translation.Submit] = "Trimite",
        _t[Translation.RequestTranscriptModalTitle] = "Solicită transcrierea",
        _t[Translation.FormError] = "Vă rugăm să remediați erorile din formular pentru a continua.",
        _t[Translation.EndChatModalMessage] = "Sigur doriți să încheiați chatul?",
        _t[Translation.ViewChat] = "Vizualizează transcrierea",
        _t[Translation.Typing] = "Scrie",
        _t[Translation.ErrorInvalid] = "Invalid",
        _t[Translation.TranscriptRequested] = "Transcript Requested",
        _t[Translation.RequestTranscriptEmailLabel] = "Adresa dvs. de e-mail",
        _t[Translation.Yes] = "Da",
        _t[Translation.BlockedAttachmentTitle] = "Atașamente blocate",
        _t[Translation.AgentIsTyping] = "Agentul scrie...",
        _t[Translation.EndChatButton] = "Terminați  conversația",
        _t[Translation.SkipSurvey] = "Nu doresc să trimit Feedback",
        _t[Translation.ErrorRequired] = "Solicitat",
        _t[Translation.NewChat] = "Un nou Chat",
        _t[Translation.GoToSurvey] = "Evaluați-vă experiența",
        _t[Translation.ChatInputPlaceholder] = "Mesajul dumneavoastră",
        _t[Translation.Mute] = "Sună notificarea mută",
        _t[Translation.FinishedChatMoreOptions] = "Mai multe opțiuni",
        _t[Translation.EmailTranscript] = "Trimite transcrierea pe e-mail",
        _t[Translation.CloseWindow] = "Close chat window",
        _t[Translation.Title] = "Asistență",
        _t[Translation.TooEarly] = "Invalid",
        _t[Translation.TooLate] = "Invalid",
        _t[Translation.TryingReconnect] = "Încercăm să vă reconectăm",
        _t[Translation.Back] = "Înapoi",
        _t[Translation.StartChat] = "Incepe conversatia",
        _t[Translation.EndChatModalTitle] = "Termină Chat",
        _t[Translation.MinimiseWindow] = "Minimizați fereastra de conversație",
        _t[Translation.PrintTranscriptButton] = "Tipărire transcriere",
        _t[Translation.DownloadTranscriptButton] = "Descărcare transcriere",
        _t[Translation.EmptySelect] = "Nimic selectat",
        _t[Translation.NoItemsFound] = "Nu au fost găsite rezultate",
        _t[Translation.TypeToSearch] = "Căutare...",
        _t),
    _a[Language.Catalan] = (_u = {},
        _u[Translation.ChatEnded] = "El xat ha finalitzat",
        _u[Translation.ChangeLanguage] = "Cambiar l'idioma",
        _u[Translation.SurveyThanks] = "Gràcies per la seva opinó",
        _u[Translation.Unmute] = "Activa els sons de notificació",
        _u[Translation.OpenChat] = "Iniciar el xat de suport",
        _u[Translation.Error] = "Error",
        _u[Translation.BlockedAttachmentMessage] = "Siusplau habiliti pop-ups al vostre navegador per veure aquest adjunt",
        _u[Translation.RequestTranscriptButton] = "Transcripció de correu electrònic",
        _u[Translation.Cancel] = "Cancelació",
        _u[Translation.Submit] = "Enviar",
        _u[Translation.RequestTranscriptModalTitle] = "Transcripció requerida",
        _u[Translation.FormError] = "Siusplau, solucioni els errors del formulari per a continuar",
        _u[Translation.EndChatModalMessage] = "Estàs segur de que vols finalitzar el xat?",
        _u[Translation.ViewChat] = "Veure transcripció",
        _u[Translation.Typing] = "Escrivint",
        _u[Translation.ErrorInvalid] = "Invàlid",
        _u[Translation.TranscriptRequested] = "Transcripció requerida",
        _u[Translation.RequestTranscriptEmailLabel] = "La seva direcció de correu electrònic",
        _u[Translation.Yes] = "Si",
        _u[Translation.BlockedAttachmentTitle] = "Adjunts blocats",
        _u[Translation.AgentIsTyping] = "L'agent esta escrivint",
        _u[Translation.EndChatButton] = "Finalitzar el xat",
        _u[Translation.SkipSurvey] = "Ignorar enquesta",
        _u[Translation.ErrorRequired] = "Requerit",
        _u[Translation.NewChat] = "Nou xat",
        _u[Translation.GoToSurvey] = "Valoreu la vostra experiència",
        _u[Translation.ChatInputPlaceholder] = "El teu missatge",
        _u[Translation.Mute] = "Sona la notificació en silenciar",
        _u[Translation.FinishedChatMoreOptions] = "Més opcions",
        _u[Translation.EmailTranscript] = "Transcripció de correu electrònic",
        _u[Translation.CloseWindow] = "Close chat window",
        _u[Translation.Title] = "Ajuda",
        _u[Translation.TooEarly] = "Invàlid",
        _u[Translation.TooLate] = "Invàlid",
        _u[Translation.TryingReconnect] = "Tractant de conectar de nou",
        _u[Translation.Back] = "Enrere",
        _u[Translation.StartChat] = "Inicia el xat",
        _u[Translation.EndChatModalTitle] = "Xat finalitzat",
        _u[Translation.MinimiseWindow] = "Minimitzar la finestra del xat",
        _u[Translation.PrintTranscriptButton] = "Imprimir la transcripció",
        _u[Translation.DownloadTranscriptButton] = "Descarregar la transcripció",
        _u[Translation.EmptySelect] = "No s’ha seleccionat res",
        _u[Translation.NoItemsFound] = "No s’han trobat resultats",
        _u[Translation.TypeToSearch] = "Cerca...",
        _u),
    _a[Language.Malay] = (_v = {},
        _v[Translation.ChatEnded] = "Sembang telah berakhir",
        _v[Translation.ChangeLanguage] = "Tukar Bahasa",
        _v[Translation.SurveyThanks] = "Terima kasih atas maklum balas anda.",
        _v[Translation.Unmute] = "Nyahaktifkan bunyi pemberitahuan",
        _v[Translation.OpenChat] = "sokongan sembang terbuka",
        _v[Translation.Error] = "Ralat",
        _v[Translation.BlockedAttachmentMessage] = "Sila aktifkan timbulan di pelayar anda untuk melihat lampiran ini",
        _v[Translation.RequestTranscriptButton] = "Transkrip e-mel",
        _v[Translation.Cancel] = "Batalkan",
        _v[Translation.Submit] = "Hantar",
        _v[Translation.RequestTranscriptModalTitle] = "Meminta transkrip",
        _v[Translation.FormError] = "Sila perbaiki ralat dalam borang untuk meneruskan",
        _v[Translation.EndChatModalMessage] = "Adakah anda pasti mahu menamatkan sembang?",
        _v[Translation.ViewChat] = "Lihat transkrip",
        _v[Translation.Typing] = "Menaip",
        _v[Translation.ErrorInvalid] = "Tidak sah",
        _v[Translation.TranscriptRequested] = "Transkrip yang diminta",
        _v[Translation.RequestTranscriptEmailLabel] = "Alamat e-mel anda",
        _v[Translation.Yes] = "Ya",
        _v[Translation.BlockedAttachmentTitle] = "Lampiran dihalangi",
        _v[Translation.AgentIsTyping] = "Agen sedang menaip...",
        _v[Translation.EndChatButton] = "Tamatkan Perbualan",
        _v[Translation.SkipSurvey] = "Langkau maklum balas",
        _v[Translation.ErrorRequired] = "Dikehendaki",
        _v[Translation.NewChat] = "Sembang Baru",
        _v[Translation.GoToSurvey] = "Kadar pengalaman anda",
        _v[Translation.ChatInputPlaceholder] = "Mesej anda...",
        _v[Translation.Mute] = "Bunyi pemberitahuan bisu",
        _v[Translation.FinishedChatMoreOptions] = "Pilihan yang banyak",
        _v[Translation.EmailTranscript] = "Transkrip e-mel",
        _v[Translation.CloseWindow] = "Close chat window",
        _v[Translation.Title] = "Bantuan",
        _v[Translation.TooEarly] = "Tidak sah",
        _v[Translation.TooLate] = "Tidak sah",
        _v[Translation.TryingReconnect] = "Cuba menyambung semula",
        _v[Translation.Back] = "Kembali",
        _v[Translation.StartChat] = "Mula sembang",
        _v[Translation.EndChatModalTitle] = "Tamat sembang",
        _v[Translation.MinimiseWindow] = "Kecilkan Tetingkap Perbualan",
        _v[Translation.PrintTranscriptButton] = "Cetak Transkrip",
        _v[Translation.DownloadTranscriptButton] = "Muat Turun Transkrip",
        _v[Translation.EmptySelect] = "Tiada satu pun dipilih",
        _v[Translation.NoItemsFound] = "Tiada hasil ditemui",
        _v[Translation.TypeToSearch] = "Cari...",
        _v),
    _a[Language.Finnish] = (_w = {},
        _w[Translation.ChatEnded] = "Chatti on päättynyt.",
        _w[Translation.ChangeLanguage] = "Vaihda kieltä",
        _w[Translation.SurveyThanks] = "Kiitos palautteestasi",
        _w[Translation.Unmute] = "Ohita ilmoitusäänet",
        _w[Translation.OpenChat] = "avoin chat-tuki",
        _w[Translation.Error] = "Virhe",
        _w[Translation.BlockedAttachmentMessage] = "Nähdäksesi liitteen, sinun tulee sallia selaimessasi ponnahdusikkunat",
        _w[Translation.RequestTranscriptButton] = "Lähetä keskustelu sähköpostiin",
        _w[Translation.Cancel] = "Peru",
        _w[Translation.Submit] = "Lähetä",
        _w[Translation.RequestTranscriptModalTitle] = "Pyydä kopio sähköpostiin",
        _w[Translation.FormError] = "Korjaa lomakkeella olevat virheet voidaksesi jatkaa",
        _w[Translation.EndChatModalMessage] = "Oletko varma, että haluat lopettaa chatin?",
        _w[Translation.ViewChat] = "Katso keskustelu",
        _w[Translation.Typing] = "Kirjoittaa",
        _w[Translation.ErrorInvalid] = "Virheellinen",
        _w[Translation.TranscriptRequested] = "Pyyntö lähetetty",
        _w[Translation.RequestTranscriptEmailLabel] = "Sähköpostiosoitteesi",
        _w[Translation.Yes] = "Kyllä",
        _w[Translation.BlockedAttachmentTitle] = "Liitteet estetty",
        _w[Translation.AgentIsTyping] = "Asiakaspalvelija kirjoittaa...",
        _w[Translation.EndChatButton] = "Lopeta chatti",
        _w[Translation.SkipSurvey] = "Ohita palaute",
        _w[Translation.ErrorRequired] = "Pakollinen",
        _w[Translation.NewChat] = "Uusi chatti",
        _w[Translation.GoToSurvey] = "Arvostele kokemuksesi",
        _w[Translation.ChatInputPlaceholder] = "Viestisi...",
        _w[Translation.Mute] = "Mykistä ilmoitus kuulostaa",
        _w[Translation.FinishedChatMoreOptions] = "Lisää vaihtoehtoja",
        _w[Translation.EmailTranscript] = "Lähetä keskustelu sähköpostiin",
        _w[Translation.CloseWindow] = "Close chat window",
        _w[Translation.Title] = "Tuki",
        _w[Translation.TooEarly] = "Virheellinen",
        _w[Translation.TooLate] = "Virheellinen",
        _w[Translation.TryingReconnect] = "Yritetään muodostaa uutta yhteyttä",
        _w[Translation.Back] = "Takaisin",
        _w[Translation.StartChat] = "Aloita chatti",
        _w[Translation.EndChatModalTitle] = "Lopeta chatti",
        _w[Translation.MinimiseWindow] = "Pienennä chatti-ikkuna",
        _w[Translation.PrintTranscriptButton] = "Tulosta selostus",
        _w[Translation.DownloadTranscriptButton] = "Lataa selostus",
        _w[Translation.EmptySelect] = "Mitään ei ole valittu",
        _w[Translation.NoItemsFound] = "Tuloksia ei löytynyt",
        _w[Translation.TypeToSearch] = "Hae...",
        _w),
    _a[Language.Japanese] = (_x = {},
        _x[Translation.ChatEnded] = "チャットは終了しました。",
        _x[Translation.ChangeLanguage] = "言語の変更",
        _x[Translation.SurveyThanks] = "ご意見をいただきありがとうございます。",
        _x[Translation.Unmute] = "ミュート解除通知音",
        _x[Translation.OpenChat] = "オープンチャットサポート",
        _x[Translation.Error] = "エラー",
        _x[Translation.BlockedAttachmentMessage] = "この添付ファイルを表示するには、ブラウザのポップアップを有効にしてください。",
        _x[Translation.RequestTranscriptButton] = "メールトランスクリプト",
        _x[Translation.Cancel] = "キャンセル",
        _x[Translation.Submit] = "提出する",
        _x[Translation.RequestTranscriptModalTitle] = "トランスクリプトを要求",
        _x[Translation.FormError] = "フォームのエラーを修正してから続けてください",
        _x[Translation.EndChatModalMessage] = "チャットを終了しますか",
        _x[Translation.ViewChat] = "トランスクリプトを見る",
        _x[Translation.Typing] = "タイピング",
        _x[Translation.ErrorInvalid] = "無効",
        _x[Translation.TranscriptRequested] = "要求された成績証明書",
        _x[Translation.RequestTranscriptEmailLabel] = "メールアドレス",
        _x[Translation.Yes] = "はい",
        _x[Translation.BlockedAttachmentTitle] = "ブロックされた添付ファイル",
        _x[Translation.AgentIsTyping] = "エージェントが入力しています...",
        _x[Translation.EndChatButton] = "チャットの終了",
        _x[Translation.SkipSurvey] = "フィードバックをスキップ",
        _x[Translation.ErrorRequired] = "必須",
        _x[Translation.NewChat] = "新しいチャット",
        _x[Translation.GoToSurvey] = "あなたの経験を評価する",
        _x[Translation.ChatInputPlaceholder] = "あなたのメッセージ...",
        _x[Translation.Mute] = "ミュート通知音",
        _x[Translation.FinishedChatMoreOptions] = "より多くのオプション",
        _x[Translation.EmailTranscript] = "メールトランスクリプト",
        _x[Translation.CloseWindow] = "Close chat window",
        _x[Translation.Title] = "チャットヘルプ",
        _x[Translation.TooEarly] = "無効",
        _x[Translation.TooLate] = "無効",
        _x[Translation.TryingReconnect] = "再接続しようとしています",
        _x[Translation.Back] = "戻り",
        _x[Translation.StartChat] = "チャットを始める",
        _x[Translation.EndChatModalTitle] = "チャットを終了",
        _x[Translation.MinimiseWindow] = "チャットウィンドウの最小化",
        _x[Translation.PrintTranscriptButton] = "チャットの内容を印刷",
        _x[Translation.DownloadTranscriptButton] = "チャットの内容をダウンロード",
        _x[Translation.EmptySelect] = "選択していません。",
        _x[Translation.NoItemsFound] = "該当するものがありません。",
        _x[Translation.TypeToSearch] = "検索中・・・",
        _x),
    _a[Language.Korean] = (_y = {},
        _y[Translation.ChatEnded] = "채팅이 종료 되었습니다.",
        _y[Translation.ChangeLanguage] = "언어 변경",
        _y[Translation.SurveyThanks] = "설문에 참여해 주셔서 감사합니다.",
        _y[Translation.Unmute] = "음소거 해제 알림 음",
        _y[Translation.OpenChat] = "열린 채팅 지원",
        _y[Translation.Error] = "오류",
        _y[Translation.BlockedAttachmentMessage] = "이 첨부 파일을 보려면 브라우저에서 팝업을 활성화하십시오.",
        _y[Translation.RequestTranscriptButton] = "이메일 기록",
        _y[Translation.Cancel] = "취소",
        _y[Translation.Submit] = "제출",
        _y[Translation.RequestTranscriptModalTitle] = "기록 요청하기",
        _y[Translation.FormError] = "양식에서 오류를 바로잡은 후 계속해주세요",
        _y[Translation.EndChatModalMessage] = "정말로 채팅을 끝내시겠습니까?",
        _y[Translation.ViewChat] = "채팅 기록(대화록) 보기",
        _y[Translation.Typing] = "입력중",
        _y[Translation.ErrorInvalid] = "유효하지 않음",
        _y[Translation.TranscriptRequested] = "기록 요청됨",
        _y[Translation.RequestTranscriptEmailLabel] = "고객님의 이메일 주소",
        _y[Translation.Yes] = "네",
        _y[Translation.BlockedAttachmentTitle] = "첨부 파일 거절됨",
        _y[Translation.AgentIsTyping] = "담당자가 입력 중...",
        _y[Translation.EndChatButton] = "상담 종료",
        _y[Translation.SkipSurvey] = "설문 건너뛰기",
        _y[Translation.ErrorRequired] = "요구됨",
        _y[Translation.NewChat] = "새로운 채팅",
        _y[Translation.GoToSurvey] = "고객님의 경험을 평가 해 주시겠습니까?",
        _y[Translation.ChatInputPlaceholder] = "내 메시지...",
        _y[Translation.Mute] = "알림 음소거",
        _y[Translation.FinishedChatMoreOptions] = "옵션 더 보기",
        _y[Translation.EmailTranscript] = "이메일 기록",
        _y[Translation.CloseWindow] = "Close chat window",
        _y[Translation.Title] = "도움",
        _y[Translation.TooEarly] = "유효하지 않음",
        _y[Translation.TooLate] = "유효하지 않음",
        _y[Translation.TryingReconnect] = "연결을 다시 시도하고 있습니다.",
        _y[Translation.Back] = "뒤로 가기",
        _y[Translation.StartChat] = "채팅 시작하기",
        _y[Translation.EndChatModalTitle] = "채팅 종료",
        _y[Translation.MinimiseWindow] = "상담창 최소화",
        _y[Translation.PrintTranscriptButton] = "채팅 내용 인쇄",
        _y[Translation.DownloadTranscriptButton] = "채팅 내용 다운로드",
        _y[Translation.EmptySelect] = "선택된 항목 없음",
        _y[Translation.NoItemsFound] = "결과를 찾을 수 없음",
        _y[Translation.TypeToSearch] = "검색...",
        _y),
    _a[Language.Chinese] = (_z = {},
        _z[Translation.ChatEnded] = "聊天已经结束。",
        _z[Translation.ChangeLanguage] = "變更語言",
        _z[Translation.SurveyThanks] = "感谢您的反馈意见。",
        _z[Translation.Unmute] = "取消靜音通知聲音",
        _z[Translation.OpenChat] = "打开聊天支持",
        _z[Translation.Error] = "错误",
        _z[Translation.BlockedAttachmentMessage] = "请启用弹出式窗口在浏览器中查看该附件。",
        _z[Translation.RequestTranscriptButton] = "电子邮件成绩单",
        _z[Translation.Cancel] = "取消",
        _z[Translation.Submit] = "提交",
        _z[Translation.RequestTranscriptModalTitle] = "申请成绩单",
        _z[Translation.FormError] = "請修正表格上的錯誤以繼續",
        _z[Translation.EndChatModalMessage] = "你确定你想结束聊天？",
        _z[Translation.ViewChat] = "观看文稿",
        _z[Translation.Typing] = "打字",
        _z[Translation.ErrorInvalid] = "无效",
        _z[Translation.TranscriptRequested] = "成绩单请求",
        _z[Translation.RequestTranscriptEmailLabel] = "您的电子邮件地址",
        _z[Translation.Yes] = "是",
        _z[Translation.BlockedAttachmentTitle] = "附件阻止",
        _z[Translation.AgentIsTyping] = "專員正在輸入……",
        _z[Translation.EndChatButton] = "結束聊天",
        _z[Translation.SkipSurvey] = "跳过反馈",
        _z[Translation.ErrorRequired] = "需要",
        _z[Translation.NewChat] = "新的聊天室",
        _z[Translation.GoToSurvey] = "评价你的经验",
        _z[Translation.ChatInputPlaceholder] = "您的訊息……",
        _z[Translation.Mute] = "靜音通知聲音",
        _z[Translation.FinishedChatMoreOptions] = "更多的选择",
        _z[Translation.EmailTranscript] = "电子邮件成绩单",
        _z[Translation.CloseWindow] = "Close chat window",
        _z[Translation.Title] = "救命",
        _z[Translation.TooEarly] = "无效",
        _z[Translation.TooLate] = "无效",
        _z[Translation.TryingReconnect] = "正尝试重新连接",
        _z[Translation.Back] = "背部",
        _z[Translation.StartChat] = "开始聊天",
        _z[Translation.EndChatModalTitle] = "结束聊天",
        _z[Translation.MinimiseWindow] = "將聊天視窗最小化",
        _z[Translation.PrintTranscriptButton] = "打印脚本",
        _z[Translation.DownloadTranscriptButton] = "下载脚本",
        _z[Translation.EmptySelect] = "未选择任何内容",
        _z[Translation.NoItemsFound] = "未找到任何结果",
        _z[Translation.TypeToSearch] = "搜索...",
        _z),
    _a[Language.ChineseTaiwan] = (_0 = {},
        _0[Translation.ChatEnded] = "聊天已经结束。",
        _0[Translation.ChangeLanguage] = "變更語言",
        _0[Translation.SurveyThanks] = "感谢您的反馈意见。",
        _0[Translation.Unmute] = "取消靜音通知聲音",
        _0[Translation.OpenChat] = "打開聊天支持",
        _0[Translation.Error] = "错误",
        _0[Translation.BlockedAttachmentMessage] = "请启用弹出式窗口在浏览器中查看该附件。",
        _0[Translation.RequestTranscriptButton] = "电子邮件成绩单",
        _0[Translation.Cancel] = "取消",
        _0[Translation.Submit] = "提交",
        _0[Translation.RequestTranscriptModalTitle] = "申请成绩单",
        _0[Translation.FormError] = "請修正表格上的錯誤即可繼續",
        _0[Translation.EndChatModalMessage] = "你确定你想结束聊天？",
        _0[Translation.ViewChat] = "观看文稿",
        _0[Translation.Typing] = "打字",
        _0[Translation.ErrorInvalid] = "无效",
        _0[Translation.TranscriptRequested] = "成绩单请求",
        _0[Translation.RequestTranscriptEmailLabel] = "您的电子邮件地址",
        _0[Translation.Yes] = "是",
        _0[Translation.BlockedAttachmentTitle] = "附件阻止",
        _0[Translation.AgentIsTyping] = "服務人員正在輸入……",
        _0[Translation.EndChatButton] = "結束交談",
        _0[Translation.SkipSurvey] = "跳过反馈",
        _0[Translation.ErrorRequired] = "需要",
        _0[Translation.NewChat] = "新的聊天室",
        _0[Translation.GoToSurvey] = "评价你的经验",
        _0[Translation.ChatInputPlaceholder] = "您的訊息……",
        _0[Translation.Mute] = "靜音通知聲音",
        _0[Translation.FinishedChatMoreOptions] = "更多的选择",
        _0[Translation.EmailTranscript] = "电子邮件成绩单",
        _0[Translation.CloseWindow] = "Close chat window",
        _0[Translation.Title] = "救命",
        _0[Translation.TooEarly] = "无效",
        _0[Translation.TooLate] = "无效",
        _0[Translation.TryingReconnect] = "正尝试重新连接",
        _0[Translation.Back] = "背部",
        _0[Translation.StartChat] = "开始聊天",
        _0[Translation.EndChatModalTitle] = "结束聊天",
        _0[Translation.MinimiseWindow] = "將聊天室視窗最小化",
        _0[Translation.PrintTranscriptButton] = "列印聊天內容",
        _0[Translation.DownloadTranscriptButton] = "下載聊天內容",
        _0[Translation.EmptySelect] = "沒有選取項目",
        _0[Translation.NoItemsFound] = "無結果",
        _0[Translation.TypeToSearch] = "搜尋...",
        _0),
    _a[Language.Danish] = (_1 = {},
        _1[Translation.ChatEnded] = "Chat er afsluttet",
        _1[Translation.ChangeLanguage] = "Ændr sprog",
        _1[Translation.SurveyThanks] = "Tak for din tilbagemelding",
        _1[Translation.Unmute] = "Dæmp underretningslyde",
        _1[Translation.OpenChat] = "åben chat support",
        _1[Translation.Error] = "Forkert",
        _1[Translation.BlockedAttachmentMessage] = "Tillad popup-vinduer i din browser for at se vedhæftet fil.",
        _1[Translation.RequestTranscriptButton] = "Kopi af e-mail",
        _1[Translation.Cancel] = "Afbestille",
        _1[Translation.Submit] = "Indsend",
        _1[Translation.RequestTranscriptModalTitle] = "Anmod om en kopi",
        _1[Translation.FormError] = "Ret venligst fejlene i formularen for at fortsætte",
        _1[Translation.EndChatModalMessage] = "Er du sikker på, at du vil afslutte chatten?",
        _1[Translation.ViewChat] = "Se kopi",
        _1[Translation.Typing] = "skriver",
        _1[Translation.ErrorInvalid] = "Ikke gyldig",
        _1[Translation.TranscriptRequested] = "Forespørgsel sendt",
        _1[Translation.RequestTranscriptEmailLabel] = "Din e-mail adresse",
        _1[Translation.Yes] = "Ja",
        _1[Translation.BlockedAttachmentTitle] = "Vedhæftet fil blokeret",
        _1[Translation.AgentIsTyping] = "Medarbejder skriver ...",
        _1[Translation.EndChatButton] = "Afslut chat",
        _1[Translation.SkipSurvey] = "Spring over tibagemelding",
        _1[Translation.ErrorRequired] = "Nødvendigt",
        _1[Translation.NewChat] = "Ny chat",
        _1[Translation.GoToSurvey] = "Overvej din oplevelse",
        _1[Translation.ChatInputPlaceholder] = "Din besked ...",
        _1[Translation.Mute] = "Lyd om lydlyd",
        _1[Translation.FinishedChatMoreOptions] = "flere muligheder",
        _1[Translation.EmailTranscript] = "Send kopi via e-mail",
        _1[Translation.CloseWindow] = "Close chat window",
        _1[Translation.Title] = "Hjælp",
        _1[Translation.TooEarly] = "Ikke gyldig",
        _1[Translation.TooLate] = "Ikke gyldig",
        _1[Translation.TryingReconnect] = "Forsøger at genoprette forbindelse",
        _1[Translation.Back] = "tilbage",
        _1[Translation.StartChat] = "chat med os",
        _1[Translation.EndChatModalTitle] = "Afslut chat",
        _1[Translation.MinimiseWindow] = "Minimér chatvindue",
        _1[Translation.PrintTranscriptButton] = "Udskriv kopi",
        _1[Translation.DownloadTranscriptButton] = "Download kopi",
        _1[Translation.EmptySelect] = "Intet valgt",
        _1[Translation.NoItemsFound] = "Ingen resultater fundet",
        _1[Translation.TypeToSearch] = "Søg...",
        _1),
    _a[Language.Slovenian] = (_2 = {},
        _2[Translation.ChatEnded] = "Prekinitev spletnega pogovora",
        _2[Translation.ChangeLanguage] = "Spremeni jezik",
        _2[Translation.SurveyThanks] = "Hvala za Vaše mnenje",
        _2[Translation.Unmute] = "Vklopi se zvok obvestila",
        _2[Translation.OpenChat] = "odprta podpora za klepet",
        _2[Translation.Error] = "Napaka",
        _2[Translation.BlockedAttachmentMessage] = "Prosimo, če omogočite piškotke na Vašem spletnem brskalniku",
        _2[Translation.RequestTranscriptButton] = "Prepis spletne pošte",
        _2[Translation.Cancel] = "Razveljavi",
        _2[Translation.Submit] = "Potrdi",
        _2[Translation.RequestTranscriptModalTitle] = "Zahtevaj prepis",
        _2[Translation.FormError] = "Če želite nadaljevati, popravite napake v obrazcu",
        _2[Translation.EndChatModalMessage] = "Ali ste prepričani, da hočete prekiniti Vaš spletni pogovor",
        _2[Translation.ViewChat] = "Poglej prepis",
        _2[Translation.Typing] = "Tipkam",
        _2[Translation.ErrorInvalid] = "Neveljavno",
        _2[Translation.TranscriptRequested] = "Zahtevan prepis",
        _2[Translation.RequestTranscriptEmailLabel] = "Naslov spletne pošte",
        _2[Translation.Yes] = "Da",
        _2[Translation.BlockedAttachmentTitle] = "Neveljavna priponka",
        _2[Translation.AgentIsTyping] = "Zastopnik vnaša odgovor ...",
        _2[Translation.EndChatButton] = "Končaj klepet",
        _2[Translation.SkipSurvey] = "Preskoči",
        _2[Translation.ErrorRequired] = "Obvezno",
        _2[Translation.NewChat] = "Novi spletni pogovor",
        _2[Translation.GoToSurvey] = "Ocenite Vašo izkušnjo",
        _2[Translation.ChatInputPlaceholder] = "Vaše sporočilo ...",
        _2[Translation.Mute] = "Izključi zvok obvestila",
        _2[Translation.FinishedChatMoreOptions] = "Dodatno",
        _2[Translation.EmailTranscript] = "Prepis spletne pošte",
        _2[Translation.CloseWindow] = "Close chat window",
        _2[Translation.Title] = "Pomoč",
        _2[Translation.TooEarly] = "Neveljavno",
        _2[Translation.TooLate] = "Neveljavno",
        _2[Translation.TryingReconnect] = "Vzpostavljam povezavo",
        _2[Translation.Back] = "Nazaj",
        _2[Translation.StartChat] = "Začnite spletni pogovor",
        _2[Translation.EndChatModalTitle] = "Prekini spletni pogovor",
        _2[Translation.MinimiseWindow] = "Pomanjšaj okno za klepet",
        _2[Translation.PrintTranscriptButton] = "Print Transcript",
        _2[Translation.DownloadTranscriptButton] = "Download Transcript",
        _2[Translation.EmptySelect] = "Nothing selected",
        _2[Translation.NoItemsFound] = "No results found",
        _2[Translation.TypeToSearch] = "Search...",
        _2),
    _a[Language.Finnish] = (_3 = {},
        _3[Translation.ChatEnded] = "Chatti on päättynyt.",
        _3[Translation.ChangeLanguage] = "Vaihda kieltä",
        _3[Translation.SurveyThanks] = "Kiitos palautteestasi",
        _3[Translation.Unmute] = "Ohita ilmoitusäänet",
        _3[Translation.OpenChat] = "avoin chat-tuki",
        _3[Translation.Error] = "Virhe",
        _3[Translation.BlockedAttachmentMessage] = "Nähdäksesi liitteen, sinun tulee sallia selaimessasi ponnahdusikkunat",
        _3[Translation.RequestTranscriptButton] = "Lähetä keskustelu sähköpostiin",
        _3[Translation.Cancel] = "Peru",
        _3[Translation.Submit] = "Lähetä",
        _3[Translation.RequestTranscriptModalTitle] = "Pyydä kopio sähköpostiin",
        _3[Translation.FormError] = "Korjaa lomakkeella olevat virheet voidaksesi jatkaa",
        _3[Translation.EndChatModalMessage] = "Oletko varma, että haluat lopettaa chatin?",
        _3[Translation.ViewChat] = "Katso keskustelu",
        _3[Translation.Typing] = "Kirjoittaa",
        _3[Translation.ErrorInvalid] = "Virheellinen",
        _3[Translation.TranscriptRequested] = "Pyyntö lähetetty",
        _3[Translation.RequestTranscriptEmailLabel] = "Sähköpostiosoitteesi",
        _3[Translation.Yes] = "Kyllä",
        _3[Translation.BlockedAttachmentTitle] = "Liitteet estetty",
        _3[Translation.AgentIsTyping] = "Asiakaspalvelija kirjoittaa...",
        _3[Translation.EndChatButton] = "Lopeta chatti",
        _3[Translation.SkipSurvey] = "Ohita palaute",
        _3[Translation.ErrorRequired] = "Pakollinen",
        _3[Translation.NewChat] = "Uusi chatti",
        _3[Translation.GoToSurvey] = "Arvostele kokemuksesi",
        _3[Translation.ChatInputPlaceholder] = "Viestisi...",
        _3[Translation.Mute] = "Mykistä ilmoitus kuulostaa",
        _3[Translation.FinishedChatMoreOptions] = "Lisää vaihtoehtoja",
        _3[Translation.EmailTranscript] = "Lähetä keskustelu sähköpostiin",
        _3[Translation.CloseWindow] = "Close chat window",
        _3[Translation.Title] = "Tuki",
        _3[Translation.TooEarly] = "Virheellinen",
        _3[Translation.TooLate] = "Virheellinen",
        _3[Translation.TryingReconnect] = "Yritetään muodostaa uutta yhteyttä",
        _3[Translation.Back] = "Takaisin",
        _3[Translation.StartChat] = "Aloita chatti",
        _3[Translation.EndChatModalTitle] = "Lopeta chatti",
        _3[Translation.MinimiseWindow] = "Pienennä chatti-ikkuna",
        _3[Translation.PrintTranscriptButton] = "Tulosta selostus",
        _3[Translation.DownloadTranscriptButton] = "Lataa selostus",
        _3[Translation.EmptySelect] = "Mitään ei ole valittu",
        _3[Translation.NoItemsFound] = "Tuloksia ei löytynyt",
        _3[Translation.TypeToSearch] = "Hae...",
        _3),
    _a[Language.Czech] = (_4 = {},
        _4[Translation.ChatEnded] = "Chat skončil.",
        _4[Translation.ChangeLanguage] = "Změnit jazyk",
        _4[Translation.SurveyThanks] = "Děkujeme za vaši zpětnou vazbu.",
        _4[Translation.Unmute] = "Zazní zvuky upozornění",
        _4[Translation.OpenChat] = "otevřená podpora chatu",
        _4[Translation.Error] = "Chyba",
        _4[Translation.BlockedAttachmentMessage] = "Chcete-li zobrazit tuto přílohu, povolte ve svém prohlížeči vyskakovací okna.",
        _4[Translation.RequestTranscriptButton] = "Poslat přepis e-mailem",
        _4[Translation.Cancel] = "Zrušit",
        _4[Translation.Submit] = "Odeslat",
        _4[Translation.RequestTranscriptModalTitle] = "Vyžádat si přepis",
        _4[Translation.FormError] = "Chcete-li pokračovat, opravte chyby ve formuláři",
        _4[Translation.EndChatModalMessage] = "Opravdu chcete tento chat ukončit?",
        _4[Translation.ViewChat] = "Zobrazit přepis",
        _4[Translation.Typing] = "píšu",
        _4[Translation.ErrorInvalid] = "Neplatné",
        _4[Translation.TranscriptRequested] = "Přepis vyžádán",
        _4[Translation.RequestTranscriptEmailLabel] = "Vaše e-mailová adresa",
        _4[Translation.Yes] = "Ano",
        _4[Translation.BlockedAttachmentTitle] = "Přílohy blokovány",
        _4[Translation.AgentIsTyping] = "Zprostředkovatel píše...",
        _4[Translation.EndChatButton] = "Ukončit chat",
        _4[Translation.SkipSurvey] = "Přeskočit zpětnou vazbu",
        _4[Translation.ErrorRequired] = "Vyžadováno",
        _4[Translation.NewChat] = "Nový chat",
        _4[Translation.GoToSurvey] = "Ohodnoťte svou zkušenost",
        _4[Translation.ChatInputPlaceholder] = "Vaše zpráva...",
        _4[Translation.Mute] = "Ztlumit zvuky upozornění",
        _4[Translation.FinishedChatMoreOptions] = "Více možností",
        _4[Translation.EmailTranscript] = "Poslat přepis e-mailem",
        _4[Translation.CloseWindow] = "Close chat window",
        _4[Translation.Title] = "Pomoc",
        _4[Translation.TooEarly] = "Neplatné",
        _4[Translation.TooLate] = "Neplatné",
        _4[Translation.TryingReconnect] = "Pokouším se o nové spojení",
        _4[Translation.Back] = "Zpět",
        _4[Translation.StartChat] = "Zahájit chat",
        _4[Translation.EndChatModalTitle] = "Ukončit chat",
        _4[Translation.MinimiseWindow] = "Minimalizovat okno chatu",
        _4[Translation.PrintTranscriptButton] = "Vytisknout přepis",
        _4[Translation.DownloadTranscriptButton] = "Stáhnout přepis",
        _4[Translation.EmptySelect] = "Nic nebylo vybráno",
        _4[Translation.NoItemsFound] = "Nebyly nalezeny žádné výsledky",
        _4[Translation.TypeToSearch] = "Vyhledávání...",
        _4),
    _a[Language.Indonesian] = (_5 = {},
        _5[Translation.ChatEnded] = "Obrolan telah berakhir.",
        _5[Translation.ChangeLanguage] = "Ganti Bahasa",
        _5[Translation.SurveyThanks] = "Terima kasih atas umpan balik Anda.",
        _5[Translation.Unmute] = "Suarakan suara notifikasi",
        _5[Translation.OpenChat] = "buka dukungan obrolan",
        _5[Translation.Error] = "Eror",
        _5[Translation.BlockedAttachmentMessage] = "Harap aktifkan munculan di peramban Anda untuk melihat lampiran ini.",
        _5[Translation.RequestTranscriptButton] = "Kirim Transkripsi ke Surel",
        _5[Translation.Cancel] = "Batalkan",
        _5[Translation.Submit] = "Kirimkan",
        _5[Translation.RequestTranscriptModalTitle] = "Minta Transkripsi",
        _5[Translation.FormError] = "Harap perbaiki kesalahan pada formulir untuk melanjutkan",
        _5[Translation.EndChatModalMessage] = "Anda yakin ingin mengakhiri obrolan?",
        _5[Translation.ViewChat] = "Lihat Transkripsi",
        _5[Translation.Typing] = "mengetik",
        _5[Translation.ErrorInvalid] = "Tidak Benar",
        _5[Translation.TranscriptRequested] = "Transkripsi Telah Diminta",
        _5[Translation.RequestTranscriptEmailLabel] = "Alamat surel Anda",
        _5[Translation.Yes] = "Ya",
        _5[Translation.BlockedAttachmentTitle] = "Lampiran Diblokir",
        _5[Translation.AgentIsTyping] = "Agen sedang mengetik...",
        _5[Translation.EndChatButton] = "Akhiri Obrolan",
        _5[Translation.SkipSurvey] = "Lewatkan Umpan Balik",
        _5[Translation.ErrorRequired] = "Wajib",
        _5[Translation.NewChat] = "Obrolan Baru",
        _5[Translation.GoToSurvey] = "Beri Nilai Pengalaman Anda",
        _5[Translation.ChatInputPlaceholder] = "Pesan Anda...",
        _5[Translation.Mute] = "Bisukan pemberitahuan berbunyi",
        _5[Translation.FinishedChatMoreOptions] = "Opsi Lainnya",
        _5[Translation.EmailTranscript] = "Kirim Transkripsi ke Surel",
        _5[Translation.CloseWindow] = "Close chat window",
        _5[Translation.Title] = "Bantuan",
        _5[Translation.TooEarly] = "Tidak Benar",
        _5[Translation.TooLate] = "Tidak Benar",
        _5[Translation.TryingReconnect] = "Mencoba menyambung kembali",
        _5[Translation.Back] = "Kembali",
        _5[Translation.StartChat] = "Mulai Obrolan",
        _5[Translation.EndChatModalTitle] = "Akhiri Obrolan",
        _5[Translation.MinimiseWindow] = "Minimalkan Jendela Obrolan",
        _5[Translation.PrintTranscriptButton] = "Cetak Transkrip",
        _5[Translation.DownloadTranscriptButton] = "Unduh Transkrip",
        _5[Translation.EmptySelect] = "Tidak ada yang dipilih",
        _5[Translation.NoItemsFound] = "Hasil pencarian tidak ditemukan",
        _5[Translation.TypeToSearch] = "Cari...",
        _5),
    _a[Language.Hungarian] = (_6 = {},
        _6[Translation.ChatEnded] = "A chat véget ért.",
        _6[Translation.ChangeLanguage] = "Válts nyelvet",
        _6[Translation.SurveyThanks] = "Köszönjük a visszajelzést.",
        _6[Translation.Unmute] = "Unmute hangértesítései",
        _6[Translation.OpenChat] = "Nyílt Chat Support",
        _6[Translation.Error] = "Hiba",
        _6[Translation.BlockedAttachmentMessage] = "Kérjük, engedélyezze a pop-up a böngészőben, hogy megtekinthesse ezt a mellékletet.",
        _6[Translation.RequestTranscriptButton] = "Email Transcript",
        _6[Translation.Cancel] = "Megszünteti",
        _6[Translation.Submit] = "Beküldés",
        _6[Translation.RequestTranscriptModalTitle] = "Request Transcript",
        _6[Translation.FormError] = "Kérjük, javítsa ki a hibákat az űrlap a folytatáshoz.",
        _6[Translation.EndChatModalMessage] = "Biztosan be szeretné fejezni a chat?",
        _6[Translation.ViewChat] = "Részletek Transcript",
        _6[Translation.Typing] = "gépelés",
        _6[Translation.ErrorInvalid] = "Érvénytelen",
        _6[Translation.TranscriptRequested] = "transcript megkeresett",
        _6[Translation.RequestTranscriptEmailLabel] = "az email címed",
        _6[Translation.Yes] = "Igen",
        _6[Translation.BlockedAttachmentTitle] = "Mellékletek Blokkolt",
        _6[Translation.AgentIsTyping] = "A szer gépelés ...",
        _6[Translation.EndChatButton] = "Csevegés vége",
        _6[Translation.SkipSurvey] = "Skip Visszajelzés",
        _6[Translation.ErrorRequired] = "Kívánt",
        _6[Translation.NewChat] = "új Chat",
        _6[Translation.GoToSurvey] = "Értékeld Te élményed",
        _6[Translation.ChatInputPlaceholder] = "Az üzeneted...",
        _6[Translation.Mute] = "Mute hangértesítései",
        _6[Translation.FinishedChatMoreOptions] = "Több lehetőség",
        _6[Translation.EmailTranscript] = "E-mail átirat",
        _6[Translation.CloseWindow] = "Bezár chat ablak",
        _6[Translation.Title] = "Segítség",
        _6[Translation.TooEarly] = "Érvénytelen",
        _6[Translation.TooLate] = "Érvénytelen",
        _6[Translation.TryingReconnect] = "Újracsatlakozási",
        _6[Translation.Back] = "Vissza",
        _6[Translation.StartChat] = "Beszélgetés indítása",
        _6[Translation.EndChatModalTitle] = "Csevegés vége",
        _6[Translation.MinimiseWindow] = "Kis méret chat ablak",
        _6[Translation.PrintTranscriptButton] = "Nyomtassa átirat",
        _6[Translation.DownloadTranscriptButton] = "Letöltés átirat",
        _6[Translation.EmptySelect] = "Nincs semmi kiválasztva",
        _6[Translation.NoItemsFound] = "Nincs találat",
        _6[Translation.TypeToSearch] = "Keresés...",
        _6),
    _a);
export default locales;
//# sourceMappingURL=chat-window-locales.js.map